<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import Image from "./columnTypes/Image.svelte"
    import IntroductionText from "./columnTypes/IntroductionText.svelte"
    import Text from "./columnTypes/Text.svelte"

    export let column: BlockColumn
    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase
</script>

<div
    class:align-self-start="{column.verticalAlign == 'top'}"
    class:align-self-center="{column.verticalAlign == 'middle'}"
    class:align-self-end="{column.verticalAlign == 'bottom'}"
    class="{column.type == 'text' ? 'textcolumn' : ''}"
>
    {#if column.type == "text"}
        <Text {column} />
    {:else if column.type == "image"}
        <Image {column} />
    {:else if column.type == "introductionText"}
        <IntroductionText {column} />
    {/if}
</div>

<style lang="less">
    div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }
</style>
